const StorageBuilder = (storage?: Storage) => ({
  setItem: (key: string, value: string) => storage?.setItem(key, value),
  getItem: (key: string) => storage?.getItem(key),
  removeItem: (key: string) => storage?.removeItem(key)
});

export const storageService = {
  local: StorageBuilder(typeof window === 'object' ? window.localStorage : undefined),
  session: StorageBuilder(typeof window === 'object' ? window.sessionStorage : undefined)
};
